import { differenceInMinutes, sub } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { DateText } from '~/eds/src/components/DateText/DateText';
import { parseDate } from '~/eds/src/utils/parseDate';
import { FormattedMessage, useIntl } from 'react-intl';

const REMINDER_MINUTE_THRESHOLD = 60;
const SECOND = 1000;

function getTimeDifference(date) {
  return differenceInMinutes(new Date(), parseDate(date));
}

function SendReminder({
  lastReminderDate = sub(new Date(), { hours: 2 }).toISOString(),
  actionHandler,
}) {
  const intl = useIntl();
  const [timeDifference, setTimeDifference] = useState(
    getTimeDifference(lastReminderDate),
  );

  useEffect(() => {
    let intervalId;
    setTimeDifference(getTimeDifference(lastReminderDate));
    intervalId = setInterval(() => {
      setTimeDifference(getTimeDifference(lastReminderDate));
    }, 60 * SECOND);

    return () => clearInterval(intervalId);
  }, [lastReminderDate]);

  const isReminderSent = timeDifference < REMINDER_MINUTE_THRESHOLD;

  const tooltip = isReminderSent ? (
    <FormattedMessage
      id="SendReminder.reminderSentTooltip"
      defaultMessage="A reminder was sent {duration}."
      description="Tooltip showing when reminder was last sent. Example: duration = '2 minutes ago'"
      values={{
        duration: (
          <DateText
            date={lastReminderDate ? new Date(lastReminderDate) : undefined}
            format="duration"
            enableTick={true}
          />
        ),
      }}
    />
  ) : undefined;

  return (
    <Button
      text={intl.formatMessage({
        id: 'SendReminder.buttonText',
        defaultMessage: 'Send Reminder',
        description: 'Button text for sending a reminder',
      })}
      icon="expiring"
      variant={isReminderSent ? 'tertiary' : 'action'}
      disabled={isReminderSent}
      tooltip={tooltip}
      onClick={() => actionHandler()}
    />
  );
}

SendReminder.propTypes = {
  lastReminderDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actionHandler: PropTypes.func,
};

export default SendReminder;
